var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./add.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-b128fd74\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./add.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/view/member/promotions/pluspricebuy/add.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] add.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b128fd74", Component.options)
  } else {
    hotAPI.reload("data-v-b128fd74", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/view/member/promotions/pluspricebuy/add.vue
// module id = 2226
// module chunks = 0